<template>
    <div
        class="input-search__input-container"
        :style="backgroundColorStyle"
    >
        <div class="input-search__input-icon">
            <i class="fa fa-search"></i>
        </div>
        <input
            :value="value"
            :style="backgroundColorStyle"
            @input="onInput($event.target.value)"
            @change="onChange($event.target.value)"
            placeholder="Поиск"
            class="input-search__input"
        >
    </div>
</template>

<script>
export default {
    name: 'InputSearch',
    /**
     * @property {string} value - значение инпута для привязки в родителе директивы v-model
     */
    props: {
        value: {
            type: String,
            default: ''
        },
        backgroundColor: {
            type: String,
            default: '#f1f3f5'
        }
    },
    data() {
        return {
            inputLazyTimerId: null
        }
    },
    computed: {
        backgroundColorStyle() {
          return {backgroundColor: this.backgroundColor};
        }
    },
    methods: {
        /**
         * событие ввода в инпут
         * @param {string} value - значение инпута
         */
        onInput(value) {
            this.$emit('input', value);

            if (this.inputLazyTimerId !== null) {
              clearTimeout(this.inputLazyTimerId);
              this.inputLazyTimerId = null;
            }

            this.inputLazyTimerId = setTimeout(() => {
              this.$emit('onInputLazy', value);
            }, 900);
        },
        /**
         * событие изменения инпута
         * @param {string} value - значение инпута
         */
        onChange(value) {
            this.$emit('change', value);
        }
    }
}
</script>

<style lang="scss" scoped>
    .input-search__input-icon {
        display: inline-block;
        margin-left: 7px;
        color: #b0b1b4;
    }
    .input-search__input-container {
        //background: #f1f3f5;
        border-radius: 100px;
        height: 32px;
    }
    .input-search__input {
        border: none;
        outline: none;
        //background: #f1f3f5;
        height: 30px;
        text-indent: 10px;
        width: 80%;
    }
    .input-search__input::placeholder {
        color: #b0b1b4;
    }
</style>